import { render, staticRenderFns } from "./ExportPOPI.vue?vue&type=template&id=6f104040&scoped=true&"
import script from "./ExportPOPI.vue?vue&type=script&lang=js&"
export * from "./ExportPOPI.vue?vue&type=script&lang=js&"
import style0 from "./ExportPOPI.vue?vue&type=style&index=0&id=6f104040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f104040",
  null
  
)

export default component.exports